module.exports = __webpack_public_path__ + "img/Logo_SA.7721a623.svg";